exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[mat-card-image] {\n  max-width: 350px; }\n\n.login-layout {\n  margin: 30px 0; }\n\n.login-form {\n  min-width: 150px;\n  max-width: 500px;\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/AppModule/LoginComponent/login.component.scss
// module id = ../../../../../src/AppModule/LoginComponent/login.component.scss
// module chunks = main